module.exports = __webpack_public_path__ + "img/codelos_clean_highlight.6931320d.gif";